import { Controller } from '@hotwired/stimulus'
import Chart from 'chart.js'

export default class extends Controller {
  static values = { url: String, type: String, title: String,
    loading: { type: Boolean, default: true },
    legend: { type: Boolean, default: true } }

  static targets = ['canvas']

  canvasTargetConnected(t) {
    this.fetch(this.urlValue)
  }

  async fetch(url, that) {
    try {
      const response = await fetch(url)
      const data = await response.json()

      const ctx = this.canvasTarget.getContext('2d')

      let options = {}

      if(this.titleValue) {
        options.title = {
          display: true,
          text: this.titleValue
        }
      }

      if(!this.legendValue) {
        options.legend = {
          display: false
        }
      }

      const chart = new Chart(ctx, { type: this.typeValue, data: data, options: options })

      this.loadingValue = false
    } catch (error) {
      console.error('Error fetching report chart data.', error)
    }
  }

  loadingValueChanged() {
    this.element.classList.toggle('loading', this.loadingValue)
  }
}
